/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Order_Summary_CustomInputs */

const en_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

const de_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuell`)
};

const es_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizado`)
};

const fr_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalisé`)
};

const nl_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangepast`)
};

const it_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizzato`)
};

const pt_br2_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizado`)
};

const pl_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niestandardowa`)
};

const hu_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyéni`)
};

const ro_admin_external_booking_edit_order_summary_custom = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizat`)
};

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_CustomInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_custom = /** @type {((inputs?: Admin_External_Booking_Edit_Order_Summary_CustomInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_CustomInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_custom(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_custom(inputs)
	return ro_admin_external_booking_edit_order_summary_custom(inputs)
});
export { admin_external_booking_edit_order_summary_custom as "admin.external_booking_edit.order_summary.custom" }